import React from 'react';

// Modern (jjfv2) header / hero / footer
import HeaderV2 from '../../components/headerV2/HeaderV2';
import FooterV2 from '../../components/footerV2/FooterV2';
import AboutHero from '../../components/aboutHero/AboutHero';
import BlogSidebar from './BlogSidebar';
import { Helmet } from 'react-helmet';

// CSS imoports
import '../AboutUsPage/aboutV2.css';
import './blogs.css';

// Image imports
import Blog1Img from "./../../images/blogs/heart_of_service_blog.webp";

export default function HeartsofService() {
    return (
        <>
            <Helmet>
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
                <link
                    href="https://fonts.googleapis.com/css2?family=Anton&family=Inter:wght@400;500;600;700;800&display=swap"
                    rel="stylesheet"
                />

                {/* Basic Meta Tags */}
                <title>100,000 Hearts of Service: JJFIndia Reaches a National Volunteer Milestone | JJF India</title>
                <meta name="description" content="Kindness is a responsibility, not just a feeling. Celebrate the 100,000+ volunteers of JJFIndia’s SevakArmy bringing change through the power of Seva." />
                <meta name="keywords" content="JJFIndia, 100000 volunteers, Culture of Seva, Jainam Jivika Foundation, Sevak Army, Life Saver Army, Maharshi Anand Seva Puruskar, YoungJains, NSS-BHU collaboration" />
                <meta name="robots" content="index, follow" />

                {/* Canonical URL */}
                <link rel="canonical" href="https://jjfindia.com/our-bulletin/hearts-of-service" />

                {/* Open Graph */}
                <meta property="og:title" content="100,000 Hearts of Service: JJFIndia Reaches a National Volunteer Milestone | JJF India" />
                <meta property="og:description" content="Kindness is a responsibility, not just a feeling. Celebrate the 100,000+ volunteers of JJFIndia’s SevakArmy bringing change through the power of Seva." />
                <meta property="og:url" content="https://jjfindia.com/our-bulletin/hearts-of-service" />

                {/* Twitter Cards */}
                {/* <meta name="twitter:card" content={metadata.twitter?.card} /> */}
                <meta name="twitter:title" content="100,000 Hearts of Service: JJFIndia Reaches a National Volunteer Milestone | JJF India" />
                <meta name="twitter:description" content="Kindness is a responsibility, not just a feeling. Celebrate the 100,000+ volunteers of JJFIndia’s SevakArmy bringing change through the power of Seva." />
            </Helmet>

            <div className="jjfv2">
                <HeaderV2 />
                <AboutHero
                    eyebrow="Our Bulletin"
                    title="Blogs"
                    crumbs={[{ label: 'Home', to: '/' }, { label: 'Blogs' }]}
                />
            </div>
            <main className="page_content">
                    <div style={{paddingBottom: "60px", paddingTop: "60px"}} className="container">
                        <div className='single-blog-container' >
                            <div className="blog-article">
                                <h1>100,000 Hearts of Service: JJFIndia Reaches a National Volunteer Milestone</h1>
                                <div>
                                    <img src={Blog1Img} alt='blog' />
                                </div>
                                <div style={{display: "flex", alignContent: "flex-end", width: "100%"}}>
                                    <span style={{ width:"100%", textAlign: "right", paddingTop: "16px", paddingBottom: "16px" }}>10 November, 2023</span>
                                </div>
                                <div>
                                    <p>Sometimes, change begins simply, with a person choosing to care. Today, that care has grown into something meaningful. The Jainam Jivika Foundation (JJFIndia) has now registered over 100,000 volunteers across India, marking a significant step in strengthening community service and humanitarian support. This achievement reflects 100,000 individuals choosing kindness as a responsibility, not just a feeling.</p>
                                    <h2 className='single-blog-sub-heading' >A Culture of Seva</h2>
                                    <p>Guided by the Jain principle of <strong>Seva (selfless service)</strong>, JJFIndia works across:</p>
                                    <ul>
                                        <li>Environmental conservation</li>
                                        <li>Mental health awareness</li>
                                        <li>Blood donation support</li>
                                        <li>Eye and organ pledging awareness</li>
                                        <li>Community food programmes</li>
                                    </ul>
                                    <p>Each initiative encourages practical, consistent service - not just participation for a day. Volunteer-led Impact</p>
                                    <h2 className='single-blog-sub-heading' >Sevak Army</h2>
                                    <ul>
                                        <li>1,500+ youth engaged</li>
                                        <li>2,500+ seed packets distributed</li>
                                        <li>300+ trees planted</li>
                                    </ul>
                                    <h2 className='single-blog-sub-heading' >❤ Life Saver Army</h2>
                                    <ul>
                                        <li>150+ units of voluntary blood collected</li>
                                        <li>Helping ensure timely blood support for critical health needs.</li>
                                    </ul>
                                    <h2 className='single-blog-sub-heading' >Growing Through Trust and Collaboration</h2>
                                    <p>Schools and colleges have played a key role. During a recent awareness session, a school principal shared:</p>
                                    <p><q><i>The dedication of Mr. Saurabh Sonkar and Mr. Harshvardhan Dwivedi has inspired our students to take meaningful steps for the environment.</i></q></p>
                                    <p>Partnerships with <strong>NSS-BHU</strong> and <strong>Sir Sunderlal Hospital, IMS-BHU</strong> have strengthened local outreach and community-based service activities.</p>
                                    <p>Youth leadership is also encouraged through YoungJains, which promotes empathy, cultural awareness, and responsible action. Recently, co-founders Jainam Jain and Jivika Jain were honoured with the Maharshi Anand Seva Puruskar for their contribution to social service grounded in Jain values.</p>
                                    <h2 className='single-blog-sub-heading' >An Open Invitation</h2>
                                    <p>If you have ever felt that even a small act of help matters , you are already halfway there.</p>
                                    <p>Service does not require wealth.</p>
                                    <p>It only requires intention. And one intention can make a real difference.</p>
                                </div>
                            </div>
                            <div>
                                <BlogSidebar />
                            </div>
                        </div>                    
                    </div>
                </main>
                <div className="jjfv2">
                    <FooterV2 />
                </div>
        </>
    );
}